import { Button, Modal, Result } from '@bfe/moly';
import { invoke, web3Navigate } from '@web3/utils';
import { getDefaultIndex } from '../../store/config';
import { isNlLawRestrict, useLawRestrictModal } from '../../store/dialogs';
import { useLocale } from '../../store/i18nMessage';
import { useCloudWallet } from '../../store/userCloudWallet';
import { isBrowser } from '../../utils/trick';

export type Web3LawRestrictModalProps = {};

export function Web3LawRestrictModal(_props: Web3LawRestrictModalProps) {
  const { t, locale } = useLocale();
  const { hasCloudWallet } = useCloudWallet();
  const { visible, hide } = useLawRestrictModal();

  const isBalancePage = isBrowser ? window.location.pathname.indexOf('/web3/balance') > -1 : false;

  const showBalanceButton = invoke(() => !isBalancePage && hasCloudWallet);

  const isNlRestrict = isNlLawRestrict();

  return (
    <Modal
      modal={false}
      zIndex={getDefaultIndex()}
      open={visible}
      title={null}
      footer={null}
      closable={false}
      width={480}
      className="moly-theme-component-light"
    >
      <Result status="warning" title={t('serviceReminder')} className=" !pb-1" />
      <p className="text-sm text-bds-gray-t2 text-center leading-normal"> {t('nlNoLongerAvailable')}</p>
      <div className="flex justify-between mt-12 gap-6">
        {showBalanceButton && (
          <Button
            className="flex-1"
            variant="primary"
            onClick={() => {
              web3Navigate(`/${locale}/web3/balance`);
            }}
          >
            {t('withdraw')}
          </Button>
        )}
        {
          <Button
            className="flex-1"
            variant={showBalanceButton ? 'default' : 'primary'}
            onClick={() => {
              hide();
              if (isNlRestrict) {
                web3Navigate(`/${locale}/web3`);
              }
            }}
          >
            {isNlRestrict ? t('return_homepage') : t('cancel')}
          </Button>
        }
      </div>
    </Modal>
  );
}
